/*
 * Broadcast Theme
 *
 * Use this file to add custom JavaScript to Broadcast. Keeping customizations
 * here makes future theme updates easier to manage.
 */

(() => {
  const resourceCenterPath = '/pages/practitioner-center';
  const practitionerPagePath = '/pages/why-practitioners-trust-bioray';

  function createResourceCenterLink(className) {
    const link = document.createElement('a');
    link.href = resourceCenterPath;
    link.className = className;
    link.dataset.practitionerResourceCenterLink = '';
    link.textContent = 'Resource Center';

    return link;
  }

  function updateDesktopDropdownStagger(practitionerMenu) {
    let step = 50;

    practitionerMenu
      .querySelectorAll('.header__dropdown__inner > [data-stagger]')
      .forEach((link, index) => {
        link.style.transitionDelay = `${index * step + 10}ms`;
        step *= 0.95;
      });
  }

  function addDesktopResourceCenterLink() {
    const practitionerTopLink = Array.from(
      document.querySelectorAll('.header__menu > .menu__item > a[data-top-link]')
    ).find((link) => link.getAttribute('href')?.includes(practitionerPagePath));

    const practitionerMenu = practitionerTopLink?.closest('.menu__item');
    if (!practitionerMenu) return;

    const existingResourceCenterLink = practitionerMenu.querySelector(
      `[href="${resourceCenterPath}"]`
    );

    if (existingResourceCenterLink) {
      updateDesktopDropdownStagger(practitionerMenu);
      return;
    }

    const practitionerAccountLink = Array.from(
      practitionerMenu.querySelectorAll('.header__dropdown__inner > a.navlink--child')
    ).find((link) => link.getAttribute('href')?.includes(practitionerPagePath));

    if (!practitionerAccountLink) return;

    const resourceCenterLink = createResourceCenterLink('navlink navlink--child');
    resourceCenterLink.dataset.stagger = '';
    resourceCenterLink.innerHTML = '<span class="navtext">Resource Center</span>';
    practitionerAccountLink.insertAdjacentElement('beforebegin', resourceCenterLink);
    updateDesktopDropdownStagger(practitionerMenu);
  }

  function addMobileResourceCenterLinks() {
    document.querySelectorAll('.megamenu__mobile-only').forEach((mobileMenu) => {
      if (mobileMenu.querySelector(`[href="${resourceCenterPath}"]`)) return;

      const practitionerLink = Array.from(
        mobileMenu.querySelectorAll('a.megamenu__link')
      ).find((link) => link.getAttribute('href')?.includes(practitionerPagePath));

      if (!practitionerLink) return;

      practitionerLink.insertAdjacentElement(
        'afterend',
        createResourceCenterLink('megamenu__link')
      );
    });
  }

  function initializePractitionerNavigation() {
    if (!document.body.classList.contains('customer-practitioner')) return;

    addDesktopResourceCenterLink();
    addMobileResourceCenterLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePractitionerNavigation);
  } else {
    initializePractitionerNavigation();
  }

  document.addEventListener('shopify:section:load', initializePractitionerNavigation);
})();

document.addEventListener('theme:variant:change', (event) => {
  const accordion = event.target.querySelector('[data-variant-whats-included]');
  if (!accordion || !accordion.querySelector('template[data-variant-whats-included-id]')) return;

  const variantId = event.detail.variant?.id;
  const variantTemplate = variantId
    ? accordion.querySelector(`template[data-variant-whats-included-id="${variantId}"]`)
    : null;
  const template =
    variantTemplate || accordion.querySelector('template[data-variant-whats-included-fallback]');
  const content = accordion.querySelector('[data-variant-whats-included-content]');

  if (template && content) content.replaceChildren(template.content.cloneNode(true));
});
